import React from 'react';
import { useSelector } from 'react-redux';

import { View, BodyText, Title } from 'modules/styled';
import { useWeb3 } from 'web3/hooks';
import { ClaimBody } from './claimBody';

export function VestModal({ close }: { close: () => void }) {
  useWeb3();
  const user = useSelector((state: any) => state.auth.user);
  const canClaim = user?.balance - (user?.airdropTokens || 0);
  return (
    <View>
      <Title>Claim Unvested Coins</Title>
      <BodyText sx={{ mt: 1, mb: 4 }}>
        Transfer Vested Coins to your Ethereum Wallet
      </BodyText>
      <ClaimBody close={close} canClaim={canClaim} type="vest" />
    </View>
  );
}

export default VestModal;
